import { render } from "./Slider.vue?vue&type=template&id=d5f57960"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
script.render = render

export default script